// Сумма прописью (рубли и копейки): «Одна тысяча двести рублей 50 копеек»
const mapNumbers = {
    0: [2, 1, 'ноль'],
    1: [0, 2, 'один', 'одна'],
    2: [1, 2, 'два', 'две'],
    3: [1, 1, 'три'],
    4: [1, 1, 'четыре'],
    5: [2, 1, 'пять'],
    6: [2, 1, 'шесть'],
    7: [2, 1, 'семь'],
    8: [2, 1, 'восемь'],
    9: [2, 1, 'девять'],
    10: [2, 1, 'десять'],
    11: [2, 1, 'одиннадцать'],
    12: [2, 1, 'двенадцать'],
    13: [2, 1, 'тринадцать'],
    14: [2, 1, 'четырнадцать'],
    15: [2, 1, 'пятнадцать'],
    16: [2, 1, 'шестнадцать'],
    17: [2, 1, 'семнадцать'],
    18: [2, 1, 'восемнадцать'],
    19: [2, 1, 'девятнадцать'],
    20: [2, 1, 'двадцать'],
    30: [2, 1, 'тридцать'],
    40: [2, 1, 'сорок'],
    50: [2, 1, 'пятьдесят'],
    60: [2, 1, 'шестьдесят'],
    70: [2, 1, 'семьдесят'],
    80: [2, 1, 'восемьдесят'],
    90: [2, 1, 'девяносто'],
    100: [2, 1, 'сто'],
    200: [2, 1, 'двести'],
    300: [2, 1, 'триста'],
    400: [2, 1, 'четыреста'],
    500: [2, 1, 'пятьсот'],
    600: [2, 1, 'шестьсот'],
    700: [2, 1, 'семьсот'],
    800: [2, 1, 'восемьсот'],
    900: [2, 1, 'девятьсот'],
};

const mapOrders = [
    { gender: true, states: ['рубль', 'рубля', 'рублей'] },
    { gender: false, states: ['тысяча', 'тысячи', 'тысяч'] },
    { gender: true, states: ['миллион', 'миллиона', 'миллионов'] },
    { gender: true, states: ['миллиард', 'миллиарда', 'миллиардов'] },
    { gender: true, states: ['триллион', 'триллиона', 'триллионов'] },
];

const objKop = { gender: false, states: ['копейка', 'копейки', 'копеек'] };

const valueOf = (val, gender) => {
    const xVal = mapNumbers[val];
    if (xVal[1] === 1) {
        return xVal[2];
    }
    return xVal[2 + (gender ? 0 : 1)];
};

const from0To999 = (value, objDesc, fnAddNum, fnAddDesc) => {
    let rest = value;
    let currState = 2;
    if (Math.floor(rest / 100) > 0) {
        const curr = Math.floor(rest / 100) * 100;
        fnAddNum(valueOf(curr, objDesc.gender));
        currState = mapNumbers[curr][0];
        rest -= curr;
    }
    if (rest < 20) {
        if (Math.floor(rest) > 0) {
            fnAddNum(valueOf(rest, objDesc.gender));
            currState = mapNumbers[rest][0];
        }
    } else {
        const curr = Math.floor(rest / 10) * 10;
        fnAddNum(valueOf(curr, objDesc.gender));
        currState = mapNumbers[curr][0];
        rest -= curr;

        if (Math.floor(rest) > 0) {
            fnAddNum(valueOf(rest, objDesc.gender));
            currState = mapNumbers[rest][0];
        }
    }
    fnAddDesc(objDesc.states[currState]);
};

const propis = (amount) => {
    let int = Math.floor(amount + 0.005);
    const dec = Math.floor(((amount - int) * 100) + 0.5);
    const result = [];
    const thousands = [];
    for (; int > 0.9999; int /= 1000) {
        thousands.push(Math.floor(int % 1000));
    }
    if (thousands.length === 0) {
        thousands.push(0);
    }

    const pushToRes = (strVal) => result.push(strVal);

    for (let i = thousands.length - 1; i >= 0; i -= 1) {
        if (thousands[i] === 0) {
            continue; // eslint-disable-line no-continue
        }
        from0To999(thousands[i], mapOrders[i], pushToRes, pushToRes);
    }
    if (thousands[0] === 0) {
        // Нулевая сумма
        if (thousands.length === 1) {
            pushToRes(valueOf(0, mapOrders[0].gender));
        }
        pushToRes(mapOrders[0].states[2]);
    }
    if (result.length > 0) {
        // Первая буква — заглавная
        result[0] = result[0].match(/^(.)/)[1].toLocaleUpperCase() + result[0].match(/^.(.*)$/)[1];
    }
    result.push(dec < 10 ? `0${dec}` : `${dec}`);
    from0To999(dec, objKop, () => { }, pushToRes);
    return result.join(' ');
};

export default propis;
